var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeavyCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 10",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 6.2L1.8 3.8 0 5.6l4.2 4.2L12 2 10.2.2l-6 6z",
    fill: "currentColor"
  })));
}

var MemoSvgHeavyCheckmark = /*#__PURE__*/React.memo(SvgHeavyCheckmark);
export default MemoSvgHeavyCheckmark;